var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.9,400.5h-76v-81.8c0-4.9-4-8.8-8.8-8.8s-8.8,4-8.8,8.8v81.8h-76c-20.8,0-37.7-16.9-37.7-37.7V245h-1.7 c-9.7,0-18.1-5.9-21.5-15s-0.7-19,6.6-25.3l111.6-95.1c15.9-13.5,39-13.5,54.9,0L389,204.7c7.4,6.3,10,16.2,6.6,25.3 c-3.3,9.1-11.8,15-21.5,15h-1.7v117.8C372.5,383.6,355.6,400.5,334.9,400.5z M274.4,385h60.5c12.2,0,22.1-9.9,22.1-22.1l0-133.4 h17.2c4.7,0,6.5-3.7,6.9-4.8c0.4-1.1,1.5-5-2.1-8.1l-111.6-95.1c-10.1-8.6-24.6-8.6-34.7,0L121,216.6c-3.6,3.1-2.5,7-2.1,8.1 s2.1,4.8,6.9,4.8H143l0,133.4c0,12.2,9.9,22.1,22.1,22.1h60.5v-66.3c0-13.4,10.9-24.4,24.4-24.4c13.4,0,24.4,10.9,24.4,24.4V385z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bfcf2e8fec2a9552d5962ce1f1ce1977.svg";
export { ForwardRef as ReactComponent };